import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-modal-gap',
  templateUrl: './modal-gap.component.html',
  styleUrls: ['./modal-gap.component.css']
})
export class ModalGapComponent {
  constructor( @Inject(MAT_DIALOG_DATA) public data: any, private sanitizer: DomSanitizer ) { }


  ngOnInit() {
    console.log(this.data)
    this.separateText()
    this.orderRanking()
  }

  ranking
  orderRanking(){
    this.ranking = this.data.gap[3].sort((a, b) => b.times - a.times);
    console.log(this.ranking)
  }



  texts
  textsColored = []

  getFormattedText(text){
    const htmlString = text.join(' ');
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }



separateText() {
  // 1) Iteramos sobre cada objeto de texto
  this.data.text.forEach((textItem, textIndex) => {
    // 2) Partimos en palabras y generamos las líneas de 15
    const words = textItem.content.split(/\s+/);
    const textByLines: string[][] = [];
    let bucket: string[] = [];

    words.forEach(word => {
      bucket.push(word);
      if (bucket.length === 15) {
        textByLines.push(bucket);
        bucket = [];
      }
    });
    // empuja la última línea si quedó con <15 palabras
    if (bucket.length) {
      textByLines.push(bucket);
    }

    // 3) Asignamos siempre textByLines
    textItem.textByLines = textByLines;

    // 4) Sacamos los gaps para este texto (índice textIndex)
    const rawGapLines = this.data.gap[2][textIndex] || [];

    // 5) Recorremos cada línea y la reconstruimos coloreando
    textItem.textByLines = textByLines.map((lineWords, lineIndex) => {
      // obtenemos el gap para esta línea, o lo normalizamos a []
      const maybeGaps = rawGapLines[lineIndex];
      const gapsThisLine = Array.isArray(maybeGaps)
        ? maybeGaps.map(g => g.trim().toLowerCase())
        : (maybeGaps != null
           ? [ String(maybeGaps).trim().toLowerCase() ]
           : []);

      // ahora mapeamos palabra a palabra
      return lineWords.map(rawWord => {
        const clean = rawWord
          .replace(/\./g, '')
          .replace(/[^\p{L}\p{N}%$#-]/gu, '')
          .toLowerCase();

        if (gapsThisLine.includes(clean)) {
          return `<span style="background-color: lightgreen;">${rawWord}</span>`;
        }
        return rawWord;
      });
    });

    console.log(`Texto ${textIndex} coloreado:`, textItem.textByLines);
  });
}







}





